export const BRAND_LOGO_TOKENS = Object.freeze({
  version: 'td-monogram-trail-v1.0',
  ratio: '1:1',
  lockupRatio: '18:5',
  safeAreaPct: 12,
  minPx: 24,
  minDp: 24,
  trailStrokePx: 5,
  ballRadiusPx: 13,
  palette: Object.freeze({
    graphite: '#0B1020',
    navy: '#101828',
    primary: '#2B7CFF',
    lime: '#B7FF2A',
    cyan: '#00D4FF',
    white: '#F9FAFB',
  }),
  canonicalAssetPath: 'frontend/src/assets/brand/td-monogram-trail-symbol.svg',
  frontendAssetPath: 'frontend/src/assets/brand/td-monogram-trail-symbol.svg',
  horizontalAssetPath: 'frontend/src/assets/brand/td-monogram-trail-horizontal.svg',
  publicAssetPath: 'frontend/public/brand-assets/public/td-monogram-trail-symbol.svg',
});

export const BRAND_WORDMARK = 'Tennis Diary';
